<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-document"></i> {{ isEdit ? '编辑文章' : '新增文章' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="110px"
        label-position="right"
        size="small"
      >
        <!-- Tab 选项卡 -->
        <el-tabs v-model="activeName" class="alipay-tabs">
          <!-- 基本信息 Tab -->
          <el-tab-pane label="基本信息" name="first">
            <div class="tab-content">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="文章标题" prop="title">
                    <el-input 
                      v-model="ruleForm.title" 
                      placeholder="请输入文章标题"
                      prefix-icon="el-icon-edit"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发布日期" prop="upload_time">
                    <el-date-picker 
                      v-model="ruleForm.upload_time" 
                      type="date" 
                      placeholder="选择发布日期"
                      value-format="yyyy-MM-dd"
                      prefix-icon="el-icon-date"
                      clearable
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="文章分类" prop="cat_id">
                    <el-select 
                      v-model="ruleForm.cat_id" 
                      placeholder="请选择分类"
                      clearable
                      style="width: 100%;"
                    >
                      <el-option 
                        v-for="item in cateMenus" 
                        :key="item.id" 
                        :label="item.pid > 0 ? '|-- ' + item.name : item.name" 
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="文章属性" class="attribute-item">
                    <el-checkbox v-model="ruleForm.istop">
                      <i class="el-icon-top"></i> 置顶
                    </el-checkbox>
                    <el-checkbox v-model="ruleForm.recommond">
                      <i class="el-icon-star-on"></i> 推荐
                    </el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="封面图片">
                    <div class="cover-preview" @click="showImgDoc(1)">
                      <i v-if="!ruleForm.file_url" class="el-icon-camera preview-icon"></i>
                      <el-image 
                        v-if="ruleForm.file_url" 
                        class="preview-image" 
                        :src="ruleForm.file_url" 
                        fit="cover"
                      ></el-image>
                      <div class="preview-tip" v-if="!ruleForm.file_url">
                        点击上传封面
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="封面地址">
                    <el-input 
                      v-model="ruleForm.file_url" 
                      placeholder="封面地址会自动生成"
                      prefix-icon="el-icon-link"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="图片上传">
                    <div class="upload-wrapper">
                      <el-upload
                        class="image-uploader"
                        drag
                        action="#"
                        :before-upload="handleBeforeUpload"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        :file-list="fileList"
                        list-type="picture"
                        multiple
                        :limit="9"
                        :on-exceed="handleFileExceed"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，建议尺寸 800x600，不超过2MB</div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="视频文件">
                    <div class="upload-wrapper">
                      <el-upload
                        class="video-uploader"
                        action="#"
                        :auto-upload="false"
                        :on-change="uploadFile1"
                        :on-remove="handleFileRemove"
                        :file-list="fileList1"
                        :limit="1"
                        :on-exceed="handleFileExceed"
                      >
                        <el-button size="small" type="primary" icon="el-icon-upload">
                          点击上传视频
                        </el-button>
                        <div slot="tip" class="el-upload__tip">只能上传mp4格式视频，建议不超过100MB</div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="视频地址">
                    <el-input 
                      v-model="ruleForm.video_url" 
                      placeholder="视频地址会自动生成"
                      prefix-icon="el-icon-video-camera"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 文章详情 Tab -->
          <el-tab-pane label="文章详情" name="second">
            <div class="tab-content">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="文章简介" prop="summary">
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入文章简介..."
                      v-model="ruleForm.summary"
                      maxlength="200"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="文章内容" class="editor-item">
                    <div class="editor-wrapper">
                      <Toolbar
                        style="border-bottom: 1px solid #e4e7ed"
                        :editor="editor"
                        :defaultConfig="toolbarConfig"
                        :mode="mode"
                      />
                      <Editor
                        style="height: 450px; overflow-y: auto;"
                        v-model="ruleForm.content"
                        :defaultConfig="editorConfig"
                        :mode="mode"
                        @onCreated="onCreated"
                      />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">保存</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 图片选择弹框 -->
    <eDocList 
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import moment from 'moment'
import axios from 'axios'
import CryptoJS from "crypto-js"
import eDocList from "../common/eDocList"

export default {
  name: "newsForm",
  components: { Editor, Toolbar, eDocList },
  data() {
    return {
      activeName: 'first',
      baseUrl: '/api/',
      fileList: [],
      fileList1: [],
      
      ruleForm: {
        summary: '',
        title: '',
        upload_time: '',
        cat_id: '',
        url: '',
        id: '',
        content: '',
        file_url: '',
        video_url: '',
        istop: false,
        recommond: false
      },
      
      cateMenus: [],
      editor: null,
      
      toolbarConfig: {
        excludeKeys: ['group-video']
      },
      
      editorConfig: {
        placeholder: '请输入文章内容...',
        height: 450,
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      
      mode: 'default',
      
      rules: {
        title: [
          { required: true, message: "请输入文章标题", trigger: 'blur' },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: 'blur' }
        ],
        cat_id: [
          { required: true, message: "请选择文章分类", trigger: 'change' }
        ],
        summary: [
          { max: 200, message: "简介不能超过200个字符", trigger: 'blur' }
        ]
      },
      
      // 图片选择弹框
      formData1: {},
      title1: '',
      visible1: false,
      type_img: 1
    }
  },
  computed: {
    isEdit() {
      return this.ruleForm.id && this.ruleForm.id > 0
    }
  },
  mounted() {
    this.getCateMenus()
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.ruleForm.id = id
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    // 获取分类菜单
    getCateMenus() {
      const params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
      }
      this.$axios.findNewsCategoryTable(params).then((res) => {
        if (res.code == 200) {
          this.cateMenus = res.data || []
        }
      })
    },
    
    // 获取单条文章信息
    getOne() {
      this.$axios.newsOne({
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        id: this.ruleForm.id
      }).then((res) => {
        if (res.code == 200) {
          const item = res.data
          this.ruleForm.title = item.title
          this.ruleForm.id = item.id
          this.ruleForm.cat_id = item.cat_id
          this.ruleForm.istop = item.istop == 1
          this.ruleForm.recommond = item.recommond == 1
          this.ruleForm.content = item.content || ''
          this.ruleForm.video_url = item.video_url || ''
          this.ruleForm.file_url = item.file_url || ''
          this.ruleForm.summary = item.summary || ''
          this.ruleForm.upload_time = item.upload_time ? moment(item.upload_time * 1000).format('YYYY-MM-DD') : ''
          this.ruleForm.url = item.link || ''
          
          if (this.ruleForm.file_url) {
            this.fileList = [{
              name: '封面图片',
              url: this.ruleForm.file_url
            }]
          }
          if (this.ruleForm.video_url) {
            this.fileList1 = [{
              name: '视频文件',
              url: this.ruleForm.video_url
            }]
          }
        }
      })
    },
    
    // 提交表单
    submitForm() {
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          const params = {
            id: this.ruleForm.id || '',
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            title: this.ruleForm.title,
            cat_id: this.ruleForm.cat_id,
            file_url: this.ruleForm.file_url,
            video_url: this.ruleForm.video_url,
            link: this.ruleForm.url,
            content: this.ruleForm.content,
            summary: this.ruleForm.summary,
            recommond: this.ruleForm.recommond ? 1 : 0,
            istop: this.ruleForm.istop ? 1 : 0,
            upload_time: this.ruleForm.upload_time
          }
          
          this.$axios.newsSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              setTimeout(() => {
                this.$router.push('/newsList')
              }, 1500)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    
    // 重置表单
    resetForm() {
      this.$refs.formForRef.resetFields()
      this.ruleForm.content = ''
      this.fileList = []
      this.fileList1 = []
      this.ruleForm.istop = false
      this.ruleForm.recommond = false
    },
    
    // 返回列表
    goBack() {
      this.$router.push('/newsList')
    },
    
    // 显示图片选择弹框
    showImgDoc(type) {
      this.type_img = type
      this.title1 = "图片选择"
      this.visible1 = true
    },
    
    // 关闭图片选择弹框
    closeForm1() {
      if (this.type_img == 1 && this.formData1 && this.formData1.url) {
        this.ruleForm.file_url = this.formData1.url
        this.fileList = [{ name: '封面图片', url: this.formData1.url }]
      }
      this.visible1 = false
    },
    
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length === 0 && this.type_img !== 1) {
        // 不是封面图的情况
      }
    },
    
    handleFileRemove(file, fileList) {
      this.fileList1 = fileList
      if (fileList.length === 0) {
        this.ruleForm.video_url = ''
      }
    },
    
    handleFileExceed() {
      this.$message.warning('最多只能上传9张图片')
    },
    
    handleBeforeUpload() {
      return false
    },
    
    // 上传图片
    async uploadFile(item) {
      const file = item.raw
      
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        return
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return
      }
      
      const file_md5 = await this.calculateMD5(file)
      const file_sha1 = await this.calculateSHA1(file)
      
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: file.size
      }
      
      this.$axios.uploadOne(param).then(res => {
        if (res.code == 200) {
          this.ruleForm.file_url = res.data.url
          this.fileList.push({ name: res.data.name, url: res.data.url })
          this.$message.success('图片上传成功')
        } else {
          this.uploadToOSS(file, file.name, file.size, file.name.split('.').pop(), file_md5, file_sha1)
        }
      })
    },
    
    // 上传视频
    uploadFile1(item) {
      const file = item.raw
      
      const isVideo = file.type === 'video/mp4'
      const isLt100M = file.size / 1024 / 1024 < 100
      
      if (!isVideo) {
        this.$message.error('只能上传 MP4 格式的视频!')
        return
      }
      if (!isLt100M) {
        this.$message.error('视频大小不能超过 100MB!')
        return
      }
      
      this.uploadToOSS(file, file.name, file.size, file.name.split('.').pop(), '', '', 'video')
    },
    
    // 上传到OSS
    uploadToOSS(file, fileName, fileSize, fileExtension, file_md5, file_sha1, type) {
      this.$axios.getAliJsonCmp({}).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const path = data.path || ''
        const folder = type === 'video' ? 'video/' : 'image/'
        
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + folder + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        
        axios.post(host, request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          const fullurl = host + '/' + res.data.filename
          
          if (type === 'video') {
            this.ruleForm.video_url = fullurl
            this.fileList1 = [{ name: fileName, url: fullurl }]
            this.$message.success('视频上传成功')
          } else {
            this.ruleForm.file_url = fullurl
            this.fileList.push({ name: fileName, url: fullurl })
            this.$message.success('图片上传成功')
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('上传失败')
        })
      })
    },
    
    readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsBinaryString(file)
      })
    },
    
    async calculateMD5(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.MD5(words).toString()
      })
    },
    
    async calculateSHA1(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.SHA1(words).toString()
      })
    },
    
    // 富文本编辑器图片上传
    uploadImg(file, insertFn) {
      this.$axios.getAliJsonCmp({}).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const path = data.path || ''
        
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + 'editor/' + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        
        axios.post(host, request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          const fullurl = host + '/' + res.data.filename
          setTimeout(() => {
            insertFn(fullurl)
          }, 500)
          this.$message.success('图片上传成功')
        }).catch(error => {
          console.log(error)
          this.$message.error('图片上传失败')
        })
      })
    },
    
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    
    get_suffix(filename) {
      const pos = filename.lastIndexOf('.')
      return pos !== -1 ? filename.substring(pos) : ''
    },
    
    Ymdhis() {
      const date = new Date()
      return '' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + 
             date.getHours() + date.getMinutes() + date.getSeconds() + 
             Math.floor(Math.random() * 9000 + 1000)
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// Tabs 样式
.alipay-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 20px;
    background: #f8f9fc;
    border-radius: 8px;
    padding: 0 16px;
    
    .el-tabs__nav-wrap::after {
      display: none;
    }
    
    .el-tabs__item {
      font-size: 14px;
      font-weight: 500;
      padding: 0 20px;
      height: 44px;
      line-height: 44px;
      
      &.is-active {
        color: #1677ff;
      }
      
      &:hover {
        color: #4096ff;
      }
    }
    
    .el-tabs__active-bar {
      background: #1677ff;
      height: 3px;
    }
  }
}

// Tab 内容区域
.tab-content {
  padding: 8px 0 20px;
}

// 表单项样式
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.el-input .el-input__inner,
.el-textarea .el-textarea__inner,
.el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
  
  &:focus {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

// 属性选项样式
.attribute-item {
  .el-checkbox {
    margin-right: 24px;
  }
}

// 封面预览样式
.cover-preview {
  width: 120px;
  height: 120px;
  border: 2px dashed #e4e7ed;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fc;
  overflow: hidden;
  
  &:hover {
    border-color: #1677ff;
    background: #f0f7ff;
  }
  
  .preview-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 8px;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .preview-tip {
    font-size: 12px;
    color: #8c8f98;
  }
}

// 上传组件样式
.upload-wrapper {
  .image-uploader .el-upload-dragger {
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    background: #fafbfc;
    width: 100%;
    height: 140px;
    
    &:hover {
      border-color: #1677ff;
      background: #f0f7ff;
    }
    
    .el-icon-upload {
      font-size: 40px;
      color: #1677ff;
      margin-top: 28px;
    }
  }
  
  .el-upload__tip {
    font-size: 12px;
    color: #8c8f98;
    margin-top: 8px;
  }
}

// 富文本编辑器样式
.editor-item .el-form-item__content {
  line-height: 1;
}

.editor-wrapper {
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
  
  &:focus-within {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

// 底部按钮样式
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>

<style>
.w-e-modal {
  z-index: 999 !important;
  left: 300px !important;
  top: 300px !important;
}
</style>